import React from 'react';

import _ from 'lodash';
import {Close, Link, TextCustom} from '@vw-marketing/us-components';

import {
  filterClearButtonTextStyle,
  filterItemTextStyle,
  filterLabelStyle,
} from './helpers';
import {
  StyledAppliedFilterItem,
  StyledClearAllButtonContainer,
  StyledFilterAppliedBar,
  StyledFilterAppliedBarContainer,
  StyledFilterAppliedLabel,
  StyledFilterCleanAllButton,
  StyledFilterItemOnCloseButton,
} from './styles';
import {FilterItem} from '../../typing/used-inventory';
import {useTrackingManager} from '../../hooks/use-tracking-manager';
import {useTranslations} from '../../hooks/use-translations';
import FilterAppliedSlick from '../filter-applied-slick';

interface FilterAppliedBarProps {
  filters?: FilterItem[];
  onDeleteElement: (item: FilterItem) => void;
  onDeleteAllElements: () => void;
}

interface FilterAppliedItemProps {
  name: string;
  onClick: () => void;
  isSticky?: boolean;
}
interface ClearAllButtonProps {
  label: string;
  onClick: () => void;
}
const ClearAllButton: React.FC<ClearAllButtonProps> = ({label, onClick}) => (
  <StyledClearAllButtonContainer className="clear-all-button-container">
    <TextCustom {...filterClearButtonTextStyle}>
      {/* @ts-ignore */}
      <Link onClick={onClick} isInline>
        {label}
      </Link>
    </TextCustom>
  </StyledClearAllButtonContainer>
);

const FilterAppliedItem: React.FC<FilterAppliedItemProps> = ({
  name,
  onClick,
  isSticky,
}) => {
  return (
    <StyledAppliedFilterItem
      className="filter-applied-item"
      isSticky={isSticky}
    >
      <TextCustom {...filterItemTextStyle}>{name}</TextCustom>
      <StyledFilterItemOnCloseButton onClick={onClick}>
        <Close variant={'small'} />
      </StyledFilterItemOnCloseButton>
    </StyledAppliedFilterItem>
  );
};

const FilterAppliedBar: React.FC<FilterAppliedBarProps> = ({
  onDeleteElement,
  onDeleteAllElements,
  filters,
}) => {
  const trackingManager = useTrackingManager();
  const {appliedFilters: translation} = useTranslations().resultsSection;

  if (!filters || filters.length <= 0) return <> </>;
  return (
    <StyledFilterAppliedBarContainer className="filter-applied-container">
      <StyledFilterAppliedLabel className="filter-applied-label">
        <TextCustom {...filterLabelStyle}>{translation.label}</TextCustom>
      </StyledFilterAppliedLabel>
      <StyledFilterAppliedBar className="filter-applied-bar">
        <FilterAppliedSlick trackingManager={trackingManager}>
          {filters.map((filter: FilterItem) => (
            <FilterAppliedItem
              name={filter.value}
              onClick={onDeleteElement.bind(null, filter)}
              key={filter.key}
            />
          ))}
        </FilterAppliedSlick>
      </StyledFilterAppliedBar>
      <StyledFilterCleanAllButton className="filter-applied-button">
        <ClearAllButton
          label={translation.ctaClearAllLabel}
          onClick={onDeleteAllElements}
        />
      </StyledFilterCleanAllButton>
    </StyledFilterAppliedBarContainer>
  );
};

export default FilterAppliedBar;
